import React from "react";
import { motion } from "framer-motion";
import { STATS } from "../lib/clinic";

export const StatsCounter = () => {
  return (
    <section className="py-16 md:py-20 bg-paper border-y border-stone-200" data-testid="stats-counter">
      <div className="container-x">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10">
          {STATS.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className={`text-center md:text-left px-4 md:px-8 ${
                i > 0 ? "md:border-l border-stone-200" : ""
              }`}
              data-testid={`stat-${i}`}
            >
              <div className="heading-serif text-5xl md:text-6xl text-brand-navyDark leading-none font-medium tracking-tight">
                {s.value}
              </div>
              <div className="mt-3 text-[11px] tracking-[0.22em] uppercase text-brand-goldDark font-medium">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
